import { Router } from '@angular/router';
import { Component, Input,OnInit,Output,EventEmitter } from '@angular/core';
import { Modal, Dropdown, TABS_DIRECTIVES } from '@clr/angular';
import { VcaAlertsService } from './../../../../common/vca-alerts';

@Component({
    selector: 'upgrade-date',
    providers: [],
    styles: [require('./upgrade-date.scss')],
    templateUrl:"upgrade-date.html"
})

export  class UpgradeDate {
    @Input() title:string;
    @Output() notify: EventEmitter<string> = new EventEmitter<string>();

    private dailyHrs: any[]=[];
    private dailyMinutes:any[]=[];
    private inputDate:string="";
    private buildList:boolean=false;
    private currentHour:any;
    private currentMinutes:any;
    private timing:string="";
    private AM:boolean;
    private scheduleReady:boolean=false;

    ngOnInit() {
        let currentDate = new Date();
        this.currentMinutes = currentDate.getMinutes();
        this.currentHour = currentDate.getHours();
        console.log("this.currentHour = ",this.currentHour);
        if (this.currentHour < 12) {
            this.AM =true;
            this.timing="AM";
        } else {
            this.AM =false;
            this.timing="PM";
        }
        this.currentHour = currentDate.getHours() % 12 || 12;;
        this.inputDate = currentDate.toISOString().split('T')[0];
        this.dailyHrs.length=12;
        this.dailyMinutes.length=60;
    }
    
    confirmSchedule() {
        let scheduleDate:string="";
        let scheduleDateObj = {
            inputDate: '',
            currentHour: '',
            currentMinutes: '',
            timing: '',
        };
        scheduleDateObj.inputDate = this.inputDate;
        scheduleDateObj.currentHour=this.currentHour;
        scheduleDateObj.currentMinutes=this.currentMinutes;
        scheduleDateObj.timing=this.timing;
        this.scheduleReady=true;
        scheduleDate= this.inputDate + ":" + this.currentHour + ":" +  this.currentMinutes+ ":" + this.timing;
        this.notify.emit(scheduleDate);
    }
}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/upgradedate/upgrade-date.component.ts